import Vue from "vue";
import VueRouter from "vue-router";
//import Home from "../views/Home.vue";
import RegisterUser from "@/views/RegisterUser.vue";
import LoginUser from "@/views/LoginUser.vue";
import AllSurveys from "@/views/AllSurveys.vue";
//import Dashboard from "@/components/Dashboard.vue";
import PwdResetForm from "@/components/PwdResetForm"
import ForgotPassword from "@/views/ForgotPassword"
import Error404 from '@/views/404.vue'
import Assets from '@/components/Assets'
import store from "@/store/store.js";
//import { Store } from "vuex";
//import { use } from "vue/types/umd";

//import NProgress from 'nprogress'

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: AllSurveys,
    meta: { requiresAuth: true } 
  },
  /*
  {
    path: "/analytics",
    name: "analytics",
    component: () => import("@/views/Analytics.vue"),
    //meta: { requiresAuth: true } //This is a custom flag. We look for this setting in the BeforeEach route guard below
  },
  {
    path: "/dashboard",
    name: "dashboard",
    component: Dashboard,
    meta: { requiresAuth: true } 
  },

  {
    path: "/users",
    name: "users",
    component: () => import("@/views/Users.vue"),
    //meta: {requiresAuth: true}
  },
  */
  {
    path: "/pixel",
    name: "pixel",
    component: () => import("@/views/Pixel.vue"),
    meta: {requiresAuth: true}
  },
  {
    path: "/results/:surveyid",
    name: "results",
    props: true,
    component: () => import("@/views/Results.vue"),
    meta: {requiresAuth: true}
  },
  {
    path: "/result/:surveyid/visitor/:visitorid",
    name: "result",
    props: true,
    component: () => import("@/views/Result.vue"),
    meta: {requiresAuth: true}
  },
  {
    path: "/surveys/list",
    name: "survey-list",
    component: () => import("@/views/AllSurveys.vue"),
    meta: {requiresAuth: true}
  },
  {
    path: "/builder/:surveyid",
    name: "survey-builder",
    props: true,
    component: () => import("@/views/SurveyBuilder.vue"),
    meta: {requiresAuth: true}
  },
  {
    path: "/preview/:surveyid/start/:id?",
    props: true,
    name: "show",
    component: () => import("@/views/SurveyPreview.vue"),
  },
  /*
  {
    path: "/survey-preview/:surveyId/:initialStepId?",
    //alias: '/survey-display/:surveyId/:initialStepId?',
    name: "survey-preview",
    props: true,
    component: () => import("@/views/SurveyPreview.vue"),
  },
  */
 /*
  {
    path: "/profile",
    name: "profile",
    component: () => import("@/components/ProfileTim.vue"),
    //meta: {requiresAuth: true}
  },
  */
  /*
  {
    path: "/test",
    name: "test",
    component: () => import("@/components/Test.vue"),
  },
  {
    path: "/demo",
    name: "demo",
    component: () => import("@/components/Demo.vue"),
    meta: { requiresAuth: true } 
  },
  */
  {
    path: "/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue")
  },

  // USER //
  {
    path: "/user/register",
    name: "user-register",
    meta: {layout: "no-header-layout"},
    component: RegisterUser
  },
  {
    path: "/user/login",
    name: "user-login",
    meta: {layout: "no-header-layout"},
    component: LoginUser
    //TO DO: If already logged in, redirect to Dashboard
  },
  {
    path: "/password/reset",
    name: "forgot-password",
    meta: {layout: "no-header-layout"},
    component: ForgotPassword
  },
  {
    path: "/assets",
    name: "assets",
    component: Assets
  },
  {
    path: "/password/reset/:token",
    name: "password-reset",
    meta: {layout: "no-header-layout"},
    component: PwdResetForm
  },

  /* Default route for Not Found/ 404. Make sure this is last! */

  { path: '*', meta: {layout: "no-header-layout"}, component: Error404 }


];

/* Enable Vue History Mode */

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});


/** Before each Route:
*
* 1. Show progress bar animation
* 2. Check if desired Route requires Auth and if so, if user is logged in
* 3. If user not logged in, redirect user to login page
*
***/

//var vm = this;


router.beforeEach((to, from, next) => {

  // Start the route progress bar.
  //NProgress.start()
  //NProgress.configure({ showSpinner: false, parent: "#page" })

  //const user = localStorage.getItem('user');
  const user = store.state.auth.user;
  
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (user) {
      console.log("I am logged in. User Id: " + user.id);
      next();
    } else{
      console.log("I am not logged in.");
      next({name: "user-login"});
      
    }
    
  } else next();

});

// Complete the animation of the route progress bar.

router.afterEach(() => {
  
//  NProgress.done()
})



export default router;
